import React, { PureComponent } from "react";
import "./HelpBadge.scss";
import Classnames from "classnames";

const textLong =
    "Need Help? We are here for you 24/7: 1-866-488-7386 | Text | Chat",
  textShort = "Need Help?",
  link = "https://www.thetrevorproject.org/get-help-now/";

interface Props {
  isMobile: boolean;
  isNavOpen: boolean;
}

class HelpBadge extends PureComponent<Props> {
  render() {
    const { isMobile, isNavOpen } = this.props;
    const showBadge = (isMobile && isNavOpen) || !isMobile;

    return (
      <div className={Classnames("HelpBadge", { showBadge })}>
        <a target="_blank" href={link}>
          {isMobile ? textShort : textLong}
        </a>
      </div>
    );
  }
}

export default HelpBadge;
